import { useState } from 'react';
import type { EnvVar } from '@/api/schemas';

/** Which sheet or dialog of the page is open, and for which variable. */
export function useEnvDialogs() {
  const [creating, setCreating] = useState(false);
  const [editing, setEditing] = useState<EnvVar | undefined>();
  const [versionFor, setVersionFor] = useState<EnvVar | null>(null);
  const [revealFor, setRevealFor] = useState<EnvVar | null>(null);
  const [versionsFor, setVersionsFor] = useState<EnvVar | null>(null);
  const [deleting, setDeleting] = useState<EnvVar | null>(null);
  const [importing, setImporting] = useState(false);
  return { creating, setCreating, editing, setEditing, versionFor, setVersionFor, revealFor, setRevealFor, versionsFor, setVersionsFor, deleting, setDeleting, importing, setImporting };
}

export type EnvDialogsApi = ReturnType<typeof useEnvDialogs>;
